<div class="d-flex align-items-center" style="gap: 8px;">
	<input
    #otpInput
		*ngFor="let digit of otpCodeInput; let i = index; trackBy: trackByIndex"
		type="text"
		inputmode="numeric"
		pattern="[0-9]*"
		class="form-control standard-control text-center"
		[ngClass]="{'ng-invalid': isInvalid, 'ng-touched': isTouched}"
		maxlength="1"
		style="width: 60px; height: 56px;"
		name="otp-{{i}}"
		pKeyFilter="pint"
		(input)="onInput($event)"
		(paste)="onPaste($event)"
		(keydown)="onKeyDown($event)"
		[required]="required"
		[(ngModel)]="otpCodeInput[i]"/>
</div>
